import ClientDetailsModalSection from '../components/ClientsComps/ClientDetailsModalSection';
import ClientMutationModals from '../components/ClientsComps/ClientMutationModals';
import ShowAllClients from '../components/ClientsComps/ShowAllClients';
import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ClientProvider from '../contexts/ClientProvider';
import MutationModalProvider from '../contexts/MutationModalProvider';

const Clients = () => {
  // rendering clients page component here
  return (
    <>
      <PageTitle title='Clients' />

      <MutationModalProvider>
        <ClientProvider>
          <ShowAllClients />
          <ClientDetailsModalSection />
        </ClientProvider>
        <ClientMutationModals />
      </MutationModalProvider>
    </>
  );
};

export default Clients;
